export default {
  path: 'equipment-operational',
  name: 'equipment-operational',
  meta: {
    title: '设备运维',
    icon: 'el-icon-s-claim',
  },
  component: () => import('@/components/equipment-operational/index.vue'),
  children: [{
    path: 'wait-task',
    name: 'wait-task',
    meta: {
      title: '待办任务',
      icon: 'el-icon-set-up',
    },
    component: () => import(
      '@/components/equipment-operational/waitTask/index.vue'
    ),
  },
  {
    path: 'has-task',
    name: 'has-task',
    meta: {
      title: '已办任务',
      icon: 'el-icon-money',
    },
    component: () => import(
      '@/components/equipment-operational/hasTask/index.vue'
    ),
  },
  {
    path: 'archiving-task',
    name: 'archiving-task',
    meta: {
      title: '归档任务',
      icon: 'el-icon-data-line',
    },
    component: () => import(
      '@/components/equipment-operational/archivingTask/index.vue'
    ),
  },
  {
    path: 'quert-task',
    name: 'quert-task',
    meta: {
      title: '任务综合查询',
      icon: 'el-icon-files',
    },
    component: () => import(
      '@/components/equipment-operational/all-task/index.vue'
    ),
  }],
};
